<template>
    <div class="uk-grid-divider" uk-grid>
        <div class="uk-width-1-1" v-for="item in items">
            <div class="uk-flex-middle" uk-grid>
                <div class="uk-width-1-1 uk-width-2-3@s">
                    <div class="uk-grid-small uk-flex-middle@s" uk-grid>
                        <div class="uk-width-1-3 uk-width-auto@s" v-if="item.item.data.featured_media">
                            <figure class="uk-position-relative uk-margin-remove">
                                <span v-html="item.item.data.featured_media.data.thumbnail"></span>
                                <a :href="item.item.data.url" class="uk-position-cover"></a>
                            </figure>
                        </div>
                        <div class="uk-width-2-3 uk-width-expand@s">
                            <p class="uk-margin-remove"><a :href="item.item.data.url">{{item.item.data.present}}</a></p>
                            <p class="uk-text-small uk-margin-remove">{{item.item.data.abstract}}</p>
                            <p class="uk-text-small uk-text-muted uk-margin-remove">Cod. {{item.item.data.code}}</p>
                            <p class="uk-text-bold">€ {{item.item.data.price}}</p>
                        </div>
                    </div>
                </div>
                <div class="uk-width-1-1 uk-width-1-3@s">
                    <div class="uk-grid-small" uk-grid>
                        <div class="uk-width-1-1">
                            <a :href="item.item.data.url" class="uk-button uk-button-primary uk-width-1-1">
                                {{ $t('rubinred.ecommerce.core.action.see_more') }}
                            </a>
                        </div>
                        <div class="uk-width-1-1">
                            <wishlist-button :item="{item_type: item.item_type, item_id: item.item_id}"></wishlist-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import DataGridResults from 'js/theme-mixins/DataGridResults';

  export default {
    mixins: [DataGridResults],
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/grid/WishlistDataGridResults.vue